import PropTypes from 'prop-types';
import format from '../../../utils/format';
import styles from './performance-value.module.scss';
import { augmentClassName } from '../../../utils/GlobalCssProxy';
import { getTextValueColorClass } from '../../../utils/sharedHelpers';

const className = augmentClassName(styles);

const isNeedTextColor = (isStyleTextColor, value) => {
  return isStyleTextColor ? getTextValueColorClass(value) : '';
};

const PerformanceValue = ({ value, isStyleTextColor, sizeKey }) => {
  return (
    <>
      <span {...className(isNeedTextColor(isStyleTextColor, value))}>
        {format.number(value)}
        {value && (
          <span {...className('percentage-style')}>
            <span {...className(sizeKey)}>%</span>
          </span>
        )}
      </span>
    </>
  );

};


PerformanceValue.propTypes = {
  value: PropTypes.number,
  isStyleTextColor: PropTypes.bool,
  sizeKey: PropTypes.string
};

PerformanceValue.defaultProps = {
  isStyleTextColor: true,
  sizeKey: 'row'
};

export default PerformanceValue;
